import Http, {UrlFull} from '../Http';

export const getOptionSelect = (url, filter) =>
  Http.get(UrlFull + url + '/' + filter);
